const translations_en_US = {
    'mc.serverCore.title': 'Minecraft Server Core Download',
    'mc.serverCore.welcome': 'Welcome to the MSL server core mirror download service!',
    'mc.serverCore.description': 'Choose the right Minecraft server core for you, supporting plugins, mods, vanilla and more.',
    'mc.serverCore.categories': 'Server Categories',
    'mc.serverCore.selectType': 'Select the type of server you need',
    'mc.serverCore.selectCore': 'Select Server Core',
    'mc.serverCore.searchCore': 'Search server cores...',
    'mc.serverCore.versionList': 'Version List',
    'mc.serverCore.selectVersion': 'Select Version',
    'mc.serverCore.refresh': 'Refresh',
    'mc.serverCore.startSelect': 'Start Selecting Server',
    'mc.serverCore.selectCategoryFirst': 'Please select a server category first to view available cores.',
    'mc.serverCore.selectCoreFirst': 'Please select a server core first',
    'mc.serverCore.server': 'Server',
    'mc.serverCore.version': 'Version',
    'mc.serverCore.fileVerification': 'File Verification Info',
    'mc.serverCore.downloadStarted': 'Download started',
    'mc.serverCore.getCategoryFailed': 'Failed to get server categories',
    'mc.serverCore.networkError': 'Network error, please try again later',
    'mc.serverCore.getVersionsFailed': 'Failed to get version list',
    'mc.serverCore.networkErrorVersions': 'Network error when getting version list',
    'mc.serverCore.getDownloadLinkFailed': 'Failed to get download link',
    'mc.serverCore.networkErrorDownload': 'Network error during download',
    'mc.serverCore.coreCount': 'Cores',
    'mc.serverCore.loadingVersions': 'Loading versions...',
    'mc.serverCore.noVersionsFound': 'No available versions found.',

    // Server Categories
    'mc.serverCore.pluginsCore': 'Plugin Servers',
    'mc.serverCore.pluginsCoreDesc': 'Server cores that support Bukkit/Spigot/Paper plugins.',
    'mc.serverCore.pluginsAndModsCore_Forge': 'NeoForge Hybrid Servers',
    'mc.serverCore.pluginsAndModsCore_ForgeDesc': 'Hybrid servers supporting both NeoForge/Forge mods and plugins.',
    'mc.serverCore.pluginsAndModsCore_Fabric': 'Fabric Hybrid Servers',
    'mc.serverCore.pluginsAndModsCore_FabricDesc': 'Hybrid servers supporting both Fabric mods and plugins.',
    'mc.serverCore.modsCore_Forge': 'NeoForge Mod Servers',
    'mc.serverCore.modsCore_ForgeDesc': 'Server cores specifically for running NeoForge/Forge mods.',
    'mc.serverCore.modsCore_Fabric': 'Fabric Mod Servers',
    'mc.serverCore.modsCore_FabricDesc': 'Server cores specifically for running Fabric mods.',
    'mc.serverCore.vanillaCore': 'Vanilla Servers',
    'mc.serverCore.vanillaCoreDesc': 'Official Minecraft vanilla server cores.',
    'mc.serverCore.bedrockCore': 'Bedrock Servers',
    'mc.serverCore.bedrockCoreDesc': 'Server cores for Bedrock Edition (Mobile).',
    'mc.serverCore.proxyCore': 'Proxy Servers',
    'mc.serverCore.proxyCoreDesc': 'Proxy cores for connecting multiple servers.',

    // Common
    'common.confirm': 'Confirm',
    'common.error': 'Error',
    'common.notice': 'Notice',

    // Theme Switcher
    'theme.switcher': 'Theme',
    'theme.light': 'Light',
    'theme.dark': 'Dark',
    'theme.auto': 'Auto',

    // Service Attribution
    'mc.serverCore.attribution': 'This service is provided by <a href="https://github.com/MSLTeam" target="_blank" class="link-secondary">MSLTeam</a>. Welcome to use our <a href="https://www.mslmc.cn/" target="_blank" class="link-secondary">MSL Server Launcher</a>. The download API is from <a href="https://www.mslmc.cn/docs/other/msl-mirrors.html" target="_blank" class="link-secondary">MSL-API-V3</a>.',

    // Footer
    'footer.copyright': 'Copyright © MSLTeam 2021-2025 All Right Received.',
    'footer.icp': '粤 ICP备2023094648号-2',
};